<template lang="pug">
.about
  section.hero.is-medium.is-dark.is-bold
    .hero-body
      .container
        h1.title
          | SMS
        h2.subtitle
          | Sistema de Monitoreo y Sistematización  
        h3.subtitle
          | Versión: {{version}}
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      version: process.env.PACKAGE_VERSION
    }
  }
}
</script>
